import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScRoundReset implements ICommand
{

	public GameID : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readInt53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScRoundReset();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30013;
	}

	public getCmdName() : string
	{
		return 'ScRoundReset';
	}

}
